import { ReactNode } from 'react';

export function DarkTooltip({ children }: { children: ReactNode }) {
  return (
    <div className="rounded-md border border-[var(--anl-border)] bg-[var(--anl-surface-elev)] px-3 py-2 text-[var(--anl-text)]">
      {children}
    </div>
  );
}

export default DarkTooltip;
